import React from "react";
import { Check } from "lucide-react";
import "./SettingsCheckbox.sass";

const CHECK_ICON_SIZE = 14;

/**
 * Square checkbox of the Styles tab (po-chart-visual-spec.md §5.4): shows or hides a line or a level.
 *
 * @param {object}   props
 * @param {boolean}  props.isChecked
 * @param {(isChecked: boolean) => void} props.onChange
 * @param {string}   props.label - accessible name
 */
const SettingsCheckbox = ({ isChecked, onChange, label }) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={isChecked}
    aria-label={label}
    title={label}
    className={`settings-checkbox${isChecked ? " settings-checkbox--checked" : ""}`}
    onClick={() => onChange(!isChecked)}
  >
    <span className="settings-checkbox__box" aria-hidden="true">
      {isChecked && <Check size={CHECK_ICON_SIZE} strokeWidth={3} />}
    </span>
  </button>
);

export default SettingsCheckbox;
